import { Portal } from '@finviz/website'
import classNames from 'classnames'

import { URL_PREFIX } from './constants'
import { useKnowledgeBase } from './context'

const staticEl = document.getElementById('js-knowledge-base-static')
const rootEl = document.getElementById('js-knowledge-base-root')

interface NavigationButtonTriggerProps {
  /**
   * The route which opens when user clicks the button
   */
  initialRoute?: string
}

export function NavigationButtonTrigger({ initialRoute }: NavigationButtonTriggerProps) {
  const openKnowledgeBase = useKnowledgeBase()

  return (
    <Portal staticElement={staticEl} rootElement={rootEl}>
      <>
        <a
          href={URL_PREFIX}
          className={classNames('is-help', {
            'nav-link border-l border-[#444a57]': !FinvizSettings.hasUserPremium,
          })}
          onClick={(ev) => {
            if (ev.metaKey || window.location.pathname.startsWith(URL_PREFIX)) return
            else ev.preventDefault()

            openKnowledgeBase(initialRoute)
          }}
        >
          <span className="fa fa-question-circle"></span> Help
        </a>
      </>
    </Portal>
  )
}
